import React from 'react'
import JEOperationSettings from "./operationsettings/JEOperationSettings.js";
import AwareOperationSettings from "./operationsettings/AwareOperationSettings.js";
import JESetpointsSettings from "./setpointssettings/JESetpointsSettings.js";
import AwareSetpointsSettings from "./setpointssettings/AwareSetpointsSettings.js";
import JEStartPrioritySettings from "./startprioritysettings/JEStartPrioritySettings.js";
import AwareStartPrioritySettings from "./startprioritysettings/AwareStartPrioritySettings.js";
import DeviceTimersSettings from "./devicetimerssettings/DeviceTimersSettings.js";
import JEFilterSettings from "./filtersettings/JEFilterSettings.js";
import AwareFilterSettings from "./filtersettings/AwareFilterSettings.js";
import OldAwareFilterSettings from "./filtersettings/OldAwareFilterSettings.js";
import {configurationSubPages} from "../../../helpers/constants";
import {isAwareDevice} from '../../../helpers/helperfunctions.js'

/** Configuration subpages
 * @param {object} device device object
 * @param {string} className classes for the component wrapper
 * @param {string} selectedSubSettingsPage page to show
 * @param {function} promptForSave save function to trigger displaying group selector or confirmation (for single device)
 */
export default function SubPagesSettings({device, showOnlyReboot, className, selectedSubSettingsPage, promptForSave}) {

    switch (selectedSubSettingsPage) {
        case configurationSubPages.operation:
            if(!isAwareDevice(device.serial_number)) return <JEOperationSettings className={className} device={device} save={promptForSave}/>
            else return <AwareOperationSettings className={className} device={device} save={promptForSave} showOnlyReboot={showOnlyReboot}/>
        case configurationSubPages.setpoints:
            if(!isAwareDevice(device.serial_number)) return <JESetpointsSettings className={className} device={device} save={promptForSave}/>
            else return <AwareSetpointsSettings className={className} device={device} save={promptForSave}/>
        case configurationSubPages.timers:
            return <DeviceTimersSettings className={className} device={device} save={promptForSave}/>
        case configurationSubPages.startpriority:
            if(!isAwareDevice(device.serial_number)) return <JEStartPrioritySettings className={className} device={device} save={promptForSave}/>
            else return <AwareStartPrioritySettings className={className} device={device} save={promptForSave}/>
        case configurationSubPages.filter:
            if(!isAwareDevice(device.serial_number)) {
                return <JEFilterSettings className={className} device={device} save={promptForSave}/>
            } else if (isFirmwareOld(device.device_twin.reported.applicationVersion)) {
                return <OldAwareFilterSettings className={className} device={device} save={promptForSave}/>
            } else {
                return <AwareFilterSettings className={className} device={device} save={promptForSave}/>
            }
        default:
            throw new Error(`SubPagesSettings: reached default with value ${selectedSubSettingsPage}`)
    }
    }
    // Helper to compare firmware versions
    function isFirmwareOld(version) {
        console.log('Comparing firmware version:', version);
        if (!version) return false;
        const parts = version.split('.').map(Number);
        // Compare to 0.9.0
        if (version === '0.9.0') return false;
        // Compare to 1.5.0
        if (parts[0] < 1) return true;
        if (parts[0] === 1 && parts[1] < 5) return true;
        if (parts[0] === 1 && parts[1] === 5 && parts[2] < 0) return true;
        return false;
}